import { ApiClient } from './api';

// Base URLs from environment with sensible defaults
const BASE = (process.env.REACT_APP_API_BASE || 'http://localhost:3002').toString();
const AUTH_BASE = (process.env.REACT_APP_API_BASE_AUTH || BASE).toString();

const MACHINES_BASE = (process.env.REACT_APP_API_BASE_MACHINES || BASE).toString();
const PRODUCTS_BASE = (process.env.REACT_APP_API_BASE_PRODUCTS || BASE).toString();
const VIDEOS_BASE = (process.env.REACT_APP_API_BASE_VIDEOS || BASE).toString();
const TRANSACTIONS_BASE = (process.env.REACT_APP_API_BASE_TRANSACTIONS || BASE).toString();
const SETTINGS_BASE = (process.env.REACT_APP_API_BASE_SETTINGS || BASE).toString();

// Export per-feature clients
export const authApi = new ApiClient(AUTH_BASE, AUTH_BASE);
export const settingsApi = new ApiClient(SETTINGS_BASE, AUTH_BASE);
export const machinesApi = new ApiClient(MACHINES_BASE, AUTH_BASE);
export const productsApi = new ApiClient(PRODUCTS_BASE, AUTH_BASE);
export const videosApi = new ApiClient(VIDEOS_BASE, AUTH_BASE);
export const transactionsApi = new ApiClient(TRANSACTIONS_BASE, AUTH_BASE);

// Backward-compatibility default client (base)
export { api } from './api';
